module.exports = __webpack_public_path__ + "static/media/autopilot-mode.2cb6b6f4.png";